import { createAsyncAction } from 'typesafe-actions';

export const signOutAsync = createAsyncAction('signOut/SIGN_OUT_REQUEST', 'signOut/SIGN_OUT_SUCCESS', 'signOut/SIGN_OUT_FAILURE')<
    void,
    void,
    Error
>();
